import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loader-container">
      <div class="mesh-background">
        <div class="mesh-orb orb-1"></div>
        <div class="mesh-orb orb-2"></div>
        <div class="mesh-orb orb-3"></div>
      </div>
      
      <div class="loader-content">
        <div class="branding">
          <img src="assets/logos/logo-light.svg" alt="reGenesis" class="brand-logo" />
          <p class="tagline">Connecting People to Products, Worldwide</p>
        </div>

        <div class="svg-wrapper">
          <svg width="120" height="120" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="48" fill="rgba(255, 255, 255, 0.1)" stroke="rgba(255, 255, 255, 0.2)" stroke-width="0.5" />
            <path d="M78,38 L78,35 Q78,22 65,22 L35,22 Q22,22 22,35 L22,65 Q22,78 35,78 L65,78 Q78,78 78,65 L78,52 L55,52 L55,62 L68,62 L68,68 L32,68 L32,32 L68,32 L68,38 Z" fill="#FFF" />
            <rect width="12" height="12" x="-6" y="-6" rx="1.5" fill="#3b43fd">
              <animateMotion 
                dur="2s" 
                repeatCount="indefinite" 
                path="M55,57 H73 V65 Q73,73 65,73 H35 Q27,73 27,65 V35 Q27,27 35,27 H65 Q73,27 73,35 V40"
                calcMode="spline"
                keySplines="0.4 0 0.2 1"
              />
            </rect>
          </svg>
        </div>
      </div>

      <div class="footer-note">
        Powered by esipick.com
      </div>
    </div>
  `,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
